import { NativeType } from './enums';
import { initCallback, pushCallback, CallbackData } from './core/callback';
import { loadJS } from './utils';
import { isAlipayMP } from './env';

interface ParamBase {
  classMap: string;
  data?: any;
  dataArray?: any[];
}

interface ParamCommand extends ParamBase {
  command: string;
}

interface ParamMethod extends ParamBase {
  method: string;
}

type Param = ParamCommand | ParamMethod;

let mpLoadPromise: Promise<void>;
const loadMPJSSDKScript = () => {
  const { my } = <any>window;
  if (my) {
    return Promise.resolve(my);
  }

  if (!mpLoadPromise) {
    mpLoadPromise = loadJS('https://appx/web-view.min.js')
      .then(() => (<any>window).my);
  }
  return mpLoadPromise;
};

if (isAlipayMP) {
  loadMPJSSDKScript()
    .then(() => {
      initCallback(NativeType.MINI_PROGRAM);
    });
}

export const alipayCallNative = async (params: Param): Promise<CallbackData> => {
  await loadMPJSSDKScript();
  return new Promise((resolve, reject) => {
    const id = pushCallback({ resolve, reject });
    const data = {
      ...params,
      callbackId: id,
    } as Record<string, unknown>;
    if (!data.command && data.method) {
      data.command = data.method;
    }
    (<any>window).my.postMessage(data);
  });
};
